var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highchart',{ref:"lineChart",attrs:{"id":!_vm.isGraphPopUp ? 'line-chart' : 'pop-chart',"plotdata":_vm.plotData,"selectedInstrument":_vm.selectedInstrument}})}
var staticRenderFns = []

export { render, staticRenderFns }